import React from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { Form } from 'formik';
import { MuiForm } from 'lib/Form';
import { ImageFormField } from 'lib/form/fields/ImageFormField';
import { Row } from 'ui/Flex';
import { LoadingButton } from 'ui/buttons/LoadingButton';

export interface LocationImagesFormData {
    mainImageUrl: string;
    listingImageUrl: string;
}

export const imagesDefaults: LocationImagesFormData = {
    mainImageUrl: '',
    listingImageUrl: ''
};

interface LocationImagesFormProps {
    open: boolean;
    onSubmit: (data: LocationImagesFormData) => void;
    onPrevious: () => void;
    initialValues: LocationImagesFormData;
    isLoading?: boolean;
}

export const LocationImagesForm: React.FC<LocationImagesFormProps> = ({
    open,
    onSubmit,
    onPrevious,
    initialValues,
    isLoading
}) => {
    if (!open) {
        return null;
    }
    return (
        <MuiForm onSubmit={onSubmit} initialValues={initialValues}>
            {({ submitForm }) => (
                <Form>
                    <Box width="100%" sx={{ px: 3, pt: 1 }}>
                        <Typography variant="body2">Upload Images to show your location in-app.</Typography>
                    </Box>
                    <Box padding={3}>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <ImageFormField
                                    name="mainImageUrl"
                                    label="Banner"
                                    aspect={600 / 260}
                                    unremovable
                                    description="This will be used to represent the location throughout the app."
                                />
                            </Grid>
                            <Grid size={12}>
                                <ImageFormField
                                    name="listingImageUrl"
                                    label="Thumbnail"
                                    aspect={465 / 496}
                                    unremovable
                                    description="This will be used to represent the location within lists such as a user's favourited locations"
                                />
                            </Grid>
                            <Grid size={12}>
                                <Row align="flex-end" gutter>
                                    <Button onClick={onPrevious} color="primary" variant="outlined">
                                        Back
                                    </Button>
                                    <LoadingButton
                                        onClick={submitForm}
                                        color="primary"
                                        variant="contained"
                                        loading={isLoading}
                                    >
                                        Create Location
                                    </LoadingButton>
                                </Row>
                            </Grid>
                        </Grid>
                    </Box>
                </Form>
            )}
        </MuiForm>
    );
};
